import Snippets from "./Snippets";

interface InitializeArgs {
  gtmId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  events?: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataLayer?: any;
  dataLayerName?: string;
  auth?: string;
  preview?: string;
  nonce?: string;
  source?: string;
}

interface DataLayerArgs {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataLayer: any;
  dataLayerName?: string;
  nonce?: string;
}

const TagManager = {
  dataScript: function (
    dataLayer: string,
    dataLayerName: string,
    nonce?: string
  ) {
    const script = document.createElement("script");
    // script/noscript contents are raw text, so textContent is equivalent to
    // innerHTML here without going through the HTML parser
    script.textContent = dataLayer;
    script.setAttribute("data-testid", dataLayerName);
    if (nonce) {
      script.setAttribute("nonce", nonce);
    }
    return script;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gtm: function (args: any) {
    const snippets = Snippets.tags(args);

    const noScript = () => {
      const noscript = document.createElement("noscript");
      noscript.textContent = snippets.iframe;
      return noscript;
    };

    const script = () => {
      const script = document.createElement("script");
      script.textContent = snippets.script;
      if (args.nonce) {
        script.setAttribute("nonce", args.nonce);
      }
      return script;
    };

    const dataScript = this.dataScript(
      snippets.dataLayerVar,
      args.dataLayerName,
      args.nonce
    );

    return {
      noScript,
      script,
      dataScript,
    };
  },
  initialize: function ({
    gtmId,
    events = [],
    dataLayer = undefined,
    dataLayerName = "dataLayer",
    auth = undefined,
    preview = undefined,
    nonce = undefined,
    source = "https://googletagmanager.com/gtm.js",
  }: InitializeArgs) {
    const gtm = this.gtm({
      id: gtmId,
      events,
      dataLayer,
      dataLayerName,
      auth,
      preview,
      nonce,
      source,
    });
    if (dataLayer) document.head.appendChild(gtm.dataScript);
    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
  },
  dataLayer: function ({
    dataLayer,
    dataLayerName = "dataLayer",
    nonce,
  }: DataLayerArgs) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((window as any)[dataLayerName])
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (window as any)[dataLayerName].push(dataLayer);
    const snippets = Snippets.dataLayer(dataLayer, dataLayerName);
    const dataScript = this.dataScript(snippets, dataLayerName, nonce);
    document.head.insertBefore(dataScript, document.head.childNodes[0]);
  },
};

export default TagManager;
